export const portcallStatuses = [
  {
    id: '4fb354b8-6055-4596-a02c-8bfaf8e0e874',
    index: 1,
    name: 'Pre Arrival',
    slug: 'pre-arrival'
  },
  {
    id: 'e8e702bd-0765-4520-9b0d-455fa44ba9bc',
    index: 2,
    name: 'Berthed',
    slug: 'berthed'
  },
  {
    id: '014d1c19-64fb-4157-8d4b-dde51a889193',
    index: 3,
    name: 'Sailed',
    slug: 'sailed'
  },
  {
    id: '014d1c19-64fb-4157-8d4b-dde51a889193',
    index: 4,
    name: 'Closed',
    slug: 'closed'
  }
];
